import React, { useContext } from 'react'
import styled from '@emotion/styled'
import { SearchContext } from './SearchProvider'

const CountWrap = styled.div`
	color: ${({ theme }) => theme.colors.darkGrey};
	text-align: center;

	${({ theme }) => theme.MQ.S} {
		text-align: right;
	}
`

const determineTotalLoaded = (results, totalCount) => {
	let totalLoadedCount = (results && results.filter((result) => result.doc_type !== 'featured_listing').length) || 0

	if (totalLoadedCount > totalCount) {
		totalLoadedCount = totalCount // because ads included in count, to ensure number is never greater than total
	}

	return totalLoadedCount
}

function SearchResultsCount() {
	const { currentTab, isLoadingMoreResults, results, searchTerm } = useContext(SearchContext)

	// include sponsored business listings in count, swifttype doesn't count it in totalcount
	const resultsLoaded = results[searchTerm] ? results[searchTerm][currentTab].data : []
	const totalPages = results[searchTerm] ? results[searchTerm][currentTab].totalPages : 0
	let totalCount = results[searchTerm] ? results[searchTerm][currentTab].totalCount : 0
	totalCount = totalPages !== 0 ? totalPages * 3 + totalCount : totalCount

	const totalLoadedCount = determineTotalLoaded(resultsLoaded, totalCount)

	return (
		<CountWrap>
			{!isLoadingMoreResults && parseInt(totalCount, 10) !== 0
				? `${totalLoadedCount} of ${totalCount} Results`
				: 'No Results Found'}
		</CountWrap>
	)
}

export default SearchResultsCount
